<template>
  <div>
    <v-tabs v-model="level_tab">
      <v-tabs-slider color="yellow"></v-tabs-slider>
      <v-tab v-for="(level, i) in levels" :key="i">
        <h3>{{ objectTranslator(level, "LEVEL_NAME") }}</h3>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="level_tab" touchless>
      <v-tab-item v-for="(level, i) in levels" :key="i">
        <NumberOfApplicantsByOrderReportDisplay :level_id="level.LEVEL_ID" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import NumberOfApplicantsByOrderReportDisplay from "./NumberOfApplicantsByOrderReportDisplay";
import { objectTranslator } from "@/helper/translator";
export default {
  name: "NumberOfApplicantsByOrderReport",
  data: function() {
    return {
      level_tab: null,
    };
  },
  components: {
    NumberOfApplicantsByOrderReportDisplay,
  },
  computed: {
    levels() {
      return this.$store.state.ref.levels;
    },
  },
  methods: {
    objectTranslator,
  },
  mounted: function() {
    this.$store.dispatch("ref/getLevels");
  },
};
</script>
